import { t } from "@/i18n-js/instance";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { Typography } from "@circle-react-uikit/Typography";
import { WarningWrapper } from "./WarningWrapper";

export const MarketingCampaignBanner = ({
  shouldRenderCurrentPlan = false,
}) => {
  const { isExpiredTrial, isCommunityOnTrial } = usePlanStatus();

  const bannerTitle = () => {
    if (isCommunityOnTrial || isExpiredTrial) {
      return t("pricing_plans.marketing_campaign.banner.trials.title");
    }
    if (shouldRenderCurrentPlan) {
      return t("pricing_plans.marketing_campaign.banner.subscribers.title");
    }
    return undefined;
  };

  const bannerDescription = () => {
    if (isCommunityOnTrial || isExpiredTrial) {
      return t("pricing_plans.marketing_campaign.banner.trials.description");
    }
    if (shouldRenderCurrentPlan) {
      return t(
        "pricing_plans.marketing_campaign.banner.subscribers.description",
      );
    }
    return undefined;
  };

  const title = bannerTitle();
  const description = bannerDescription();

  if (title || description) {
    return (
      <WarningWrapper>
        {title && (
          <Typography.LabelLg weight="semibold">{title}</Typography.LabelLg>
        )}
        {description && (
          <Typography.BodyMd color="text-default">
            {description}
          </Typography.BodyMd>
        )}
      </WarningWrapper>
    );
  }

  return null;
};
